<script>
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export default {
    name: 'joinUs',
    data() {
        return {

        };
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger);
        let mm = gsap.matchMedia();

        mm.add("(min-width: 10px)", () => {
            gsap.fromTo(".item-1", {
                scale: 5, opacity: 0,
            }, {
                scale: 1, opacity: 1, duration: 1, scrollTrigger: {
                    trigger: ".joinUs",
                    start: "top bottom",
                    end: "bottom top",
                },
                boxShadow: "rgba(0, 0, 0, 1) 0px 0px 0px 0px",
                ease: 'power1.in'
            })
            gsap.fromTo(".item-7", {
                scale: 5, opacity: 0,
            }, {
                scale: 1, opacity: 1, duration: 1, scrollTrigger: {
                    trigger: ".joinUs",
                    start: "top bottom",
                    end: "bottom top",
                },
                boxShadow: "rgba(0, 0, 0, 1) 0px 0px 0px 0px",
                ease: 'power1.in',
                delay: 0.7
            })
            gsap.fromTo(".item-9", {
                scale: 5, opacity: 0,
            }, {
                scale: 1, opacity: 1, duration: .3, scrollTrigger: {
                    trigger: ".joinUs",
                    start: "top bottom",
                    end: "bottom top",
                },
                boxShadow: "rgba(0, 0, 0, 1) 0px 0px 0px 0px",
                ease: 'power1.in',
                delay: 1.7
            })
            gsap.fromTo(".item-8", {
                scale: 5, opacity: 0,
            }, {
                scale: 1, opacity: 1, duration: .3, scrollTrigger: {
                    trigger: ".joinUs",
                    start: "top bottom",
                    end: "bottom top",
                },
                boxShadow: "rgba(0, 0, 0, 1) 0px 0px 0px 0px",
                ease: 'power1.in',
                delay: 1.9
            })
            gsap.fromTo(".item-5", {
                scale: 5, opacity: 0,
            }, {
                scale: 1, opacity: 1, duration: .3, scrollTrigger: {
                    trigger: ".joinUs",
                    start: "top bottom",
                    end: "bottom top",
                },
                boxShadow: "rgba(0, 0, 0, 1) 0px 0px 0px 0px",
                ease: 'power1.in',
                delay: 2.1
            })
            gsap.fromTo(".item-6", {
                scale: 5, opacity: 0,
            }, {
                scale: 1, opacity: 1, duration: .3, scrollTrigger: {
                    trigger: ".joinUs",
                    start: "top bottom",
                    end: "bottom top",
                },
                boxShadow: "rgba(0, 0, 0, 1) 0px 0px 0px 0px",
                ease: 'power1.in',
                delay: 2.3
            })
            gsap.fromTo(".item-2", {
                scale: 5, opacity: 0,
            }, {
                scale: 1, opacity: 1, duration: .3, scrollTrigger: {
                    trigger: ".joinUs",
                    start: "top bottom",
                    end: "bottom top",
                },
                boxShadow: "rgba(0, 0, 0, 1) 0px 0px 0px 0px",
                ease: 'power1.in',
                delay: 2.5
            })
            gsap.fromTo(".item-3", {
                scale: 5, opacity: 0,
            }, {
                scale: 1, opacity: 1, duration: .3, scrollTrigger: {
                    trigger: ".joinUs",
                    start: "top bottom",
                    end: "bottom top",
                },
                boxShadow: "rgba(0, 0, 0, 1) 0px 0px 0px 0px",
                ease: 'power1.in',
                delay: 2.7
            })
            gsap.fromTo(".item-4", {
                scale: 5, opacity: 0,
            }, {
                scale: 1, opacity: 1, duration: .3, scrollTrigger: {
                    trigger: ".joinUs",
                    start: "top bottom",
                    end: "bottom top",
                },
                boxShadow: "rgba(0, 0, 0, 1) 0px 0px 0px 0px",
                ease: 'power1.in',
                delay: 2.9
            })
            gsap.fromTo(".item-11", {
                scale: 5, opacity: 0,
            }, {
                scale: 1, opacity: 1, duration: .3, scrollTrigger: {
                    trigger: ".joinUs",
                    start: "top bottom",
                    end: "bottom top",
                },
                boxShadow: "rgba(0, 0, 0, 1) 0px 0px 0px 0px",
                ease: 'power1.in',
                delay: 3.1
            })
            gsap.fromTo(".item-10", {
                scale: 5, opacity: 0,
            }, {
                scale: 1, opacity: 1, duration: .3, scrollTrigger: {
                    trigger: ".joinUs",
                    start: "top bottom",
                    end: "bottom top",
                },
                boxShadow: "rgba(0, 0, 0, 1) 0px 0px 0px 0px",
                ease: 'power1.in',
                delay: 3.3
            })
        })
    }
}
</script>

<template>
    <div class="joinUs">
        <div class="container">
            <div class="joinUs__content">
                <h2 class="joinUs__content-title">К нам присоединяются:</h2>
                <div class="joinUs__content-list">
                    <div class="joinUs__content-item item-1">
                        <p class="joinUs__content-text">школы</p>
                    </div>
                    <div class="joinUs__content-item item-2">
                        <p class="joinUs__content-text">колледжи</p>
                    </div>
                    <div class="joinUs__content-item item-3">
                        <p class="joinUs__content-text">сотрудники</p>
                    </div>
                    <div class="joinUs__content-item item-4">
                        <p class="joinUs__content-text">онлайн-школы</p>
                    </div>
                    <div class="joinUs__content-item item-5">
                        <p class="joinUs__content-text">топ-менеджеры</p>
                    </div>
                    <div class="joinUs__content-item item-6">
                        <p class="joinUs__content-text">университеты</p>
                    </div>
                    <div class="joinUs__content-item item-7">
                        <p class="joinUs__content-text">институты</p>
                    </div>
                    <div class="joinUs__content-item item-8">
                        <p class="joinUs__content-text">компании</p>
                    </div>
                    <div class="joinUs__content-item item-9">
                        <p class="joinUs__content-text">руководители</p>
                    </div>
                    <div class="joinUs__content-item item-10">
                        <p class="joinUs__content-text">студенты</p>
                    </div>
                    <div class="joinUs__content-item item-11">
                        <p class="joinUs__content-text">специалисты</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped>
.joinUs {
    overflow: hidden;
}

.joinUs__content-list {
    height: 456px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    position: relative;
}


.joinUs__content-title {
    color: #1A1A1A;
    font-family: Aeroport;
    font-size: 35px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-bottom: 47px;
}

.joinUs__content-text {
    color: #1A1A1A;
    text-align: center;
    font-family: Aeroport;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.joinUs__content-item {
    width: 231px;
    height: 84px;
    border-radius: 15px;
    border: 1px solid #D4DBDE;
    background: #FFF;
    display: flex;
    justify-content: center;
    align-items: center;
}

.joinUs__content-item.item-1 {
    position: absolute;
    top: 37px;
    left: 201px;
    transform: rotate(-6.874deg);
}

.joinUs__content-item.item-2 {
    position: absolute;
    top: 56px;
    left: 626px;
    transform: rotate(6.834deg);
}

.joinUs__content-item.item-3 {
    position: absolute;
    top: 0;
    right: 421.25px;
    transform: rotate(-3.489deg);
}

.joinUs__content-item.item-4 {
    position: absolute;
    top: 49px;
    right: 0;
    transform: rotate(8.561deg);
}

.joinUs__content-item.item-5 {
    position: absolute;
    top: 170px;
    left: 0;
    transform: rotate(6.048deg);
}

.joinUs__content-item.item-6 {
    position: absolute;
    top: 169.4px;
    left: 435px;
    transform: rotate(-3.077deg);
}

.joinUs__content-item.item-7 {
    position: absolute;
    top: 162px;
    right: 327.7px;
    transform: rotate(-7.768deg);
}

.joinUs__content-item.item-8 {
    position: absolute;
    bottom: 32px;
    left: 131px;
    transform: rotate(4.717deg);
}

.joinUs__content-item.item-9 {
    position: absolute;
    bottom: 13px;
    left: 486px;
    transform: rotate(-7.306deg);
}

.joinUs__content-item.item-10 {
    position: absolute;
    bottom: 23px;
    right: 508px;
    transform: rotate(13.557deg);
}

.joinUs__content-item.item-11 {
    position: absolute;
    bottom: 58.79px;
    right: 6.77px;
    transform: rotate(-3.882deg);
}

@media (max-width:650px) {
    .joinUs__content-title {
        font-size: 28px;
        padding-bottom: 35px;
    }

    .joinUs__content-item {
        width: 150px;
        height: 50px;
    }

    .joinUs__content-text {
        font-size: 16px;
    }
    .joinUs__content-list {
        height: 410px;
    }
    .joinUs__content-item.item-1 {
        top: 0;
        left: 25px;
        transform: rotate(-10.62deg);
    }

    .joinUs__content-item.item-2 {
        top: 11px;
        left: auto;
        right: 0;
        transform: rotate(11.43deg);
    }

    .joinUs__content-item.item-3 {
        top: 79px;
        right: auto;
        left: 12px;
        transform: rotate(-26.64deg);
        z-index: 3;
    }
    .joinUs__content-item.item-4 {
        top: auto;
        right: 24px;
        bottom: 123px;
        transform: rotate(18.97deg);
    }
    .joinUs__content-item.item-5 {
        top: 127px;
        left: 87px;
        transform: rotate(11.86deg);
        z-index: 2;
    }
    .joinUs__content-item.item-6 {
        left: auto;
        right: 33px;
        top: 74px;
        transform: rotate(-13.23deg);
    }
    .joinUs__content-item.item-7 {
        left: 0;
        right: auto;
        top: 186px;
        transform: rotate(-14.73deg);
    }
    .joinUs__content-item.item-8 {
        left: auto;
        bottom: auto;
        right: 20px;
        top: 158px;
        transform: rotate(-19.75deg);
    }
    .joinUs__content-item.item-9 {
        bottom: 28px;
        left: 50px;
        transform: rotate(-9.33deg);
        z-index: 2;
    }
    .joinUs__content-item.item-10 {
        left: 12px;
        right: auto;
        bottom: 108px;
        transform: rotate(5.03deg);
    }
    .joinUs__content-item.item-11 {
        right: 70px;
        bottom: 73px;
        transform: rotate(10.37deg);
    }
}
</style>